import { Navbar } from "../Components/Navbar/Navbar.jsx";
import Banner from "../Components/Banner/Banner.jsx";
import { Footer } from "../Components/Footer/Footer";

import photo from "../Components/Banner/contactBanner.png";
import style from "./Contact.module.css";

const Contact = () => {
  const bannerSettings = {
    photo: `${photo}`,
    circleClassName: "fullCircle",
    smallCircle: "empty",
    smallCircleTitle: "",
    title: "Queremos escucharte",
    paragraph:
      "Comunícate con nuestro equipo de servicio al cliente y con gusto te ayudaremos con lo que necesites.",
    wp: "+502 42890334",
    mail: "blancoseguroapp@gmail.com",
    btnSettings: {
      variant: "outlined",
      color: "primary",
      text: "Mandar un mensaje",
    },
  };

  return (
    <div className={style.conteiner}>
      <Navbar />
      <Banner bannerSettings={bannerSettings} />
      <Footer />
    </div>
  );
};

export default Contact;
